import { render, staticRenderFns } from "./UsageHistoryOfAmount.vue?vue&type=template&id=10a5b476&"
import script from "./UsageHistoryOfAmount.vue?vue&type=script&lang=ts&"
export * from "./UsageHistoryOfAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports